import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";
import MainEdit from "./MainEdit";

const Items = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/events/items" component={List} />
        <Route path="/admin/events/items/new" component={Add} />
        <Route path="/admin/events/items/:id" component={MainEdit} />
      </Switch>
    </Router>
  );
};
export default Items;
